import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorViewWithLogout from 'shared/ErrorPages/TwoRowErrorPage/ErrorViewWithLogout'

const NoLocation = () => {
    const { t } = useTranslation()

    return (
        <ErrorViewWithLogout message={t('ERROR_NO_LOCATION')} />
    )
}

export default NoLocation
